<template>
  <div class="warehouse-manage">
    <div class="search-warehouse">
      <div class="search">
        <el-input class="white" v-model="warehouseName" placeholder="请输入仓库名称"></el-input>
        <el-button class="btn-blue" @click="searchWarehouse">搜索</el-button>
      </div>
      <div class="add">
        <el-button class="btn-blue" @click="addWarehouse">新增</el-button>
      </div>
    </div>
    <div class="table">
      <el-table ref="table" :data="tableData" style="width: 100%">
        <el-table-column label="序号" width="120">
          <template slot-scope="scope">{{ scope.$index + 1 }}</template>
        </el-table-column>
        <el-table-column prop="name" label="仓库"></el-table-column>
        <el-table-column prop="bcPercent" label="toC业务比重">
          <template slot-scope="scope">
            <span>{{ scope.row.bcPercent }}%</span>
          </template>
        </el-table-column>
        <el-table-column prop="area" label="面积"></el-table-column>
        <el-table-column prop="rentPriceMonth" label="场租月单价"></el-table-column>
        <el-table-column prop="attendanceRule" label="考勤规制"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button class="btn-text" type="text" @click="updateWarehouse(scope.row)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 新增 -->
    <el-dialog
      :title="warehouseForm.id ? '编辑仓库' : '新增仓库'"
      top="9vh"
      :visible.sync="warehouseDialog"
      width="610px"
    >
      <div class="border"></div>
      <el-form
        ref="warehouseForm"
        :rules="warehouseFormRules"
        :model="warehouseForm"
      >
        <div class="row">
          <el-form-item label="仓库名称" prop="name">
            <el-input v-model="warehouseForm.name" class="white" placeholder="请输入仓库名称"></el-input>
          </el-form-item>
          <el-form-item label="场租月单价" prop="rentPriceMonth">
            <el-input
              v-model="warehouseForm.rentPriceMonth"
              @input="rentPriceMonthInput"
              class="white"
              placeholder="请输入场租月单价"
            ></el-input>
          </el-form-item>
        </div>
        <div class="row">
          <el-form-item label="toC业务比重" prop="bcPercent">
            <el-input
              v-model="warehouseForm.bcPercent"
              @input="bcPercentInput"
              class="white"
              placeholder="请输入0-100之间数值"
            ></el-input>
            <span class="percent">%</span>
          </el-form-item>
          <el-form-item label="面积" prop="area">
            <el-input
              v-model="warehouseForm.area"
              @input="areaInput"
              class="white"
              placeholder="请输入面积"
            ></el-input>
          </el-form-item>
        </div>
        <div class="row">
          <el-form-item label="成本分摊规则" prop="costAllocationRules">
            <el-checkbox-group v-model="warehouseForm.costAllocationRules" @change="changeCostAllocationRules">
              <el-checkbox
                v-for="(item, index) in costAllocationRulesList"
                :key="index"
                :label="item.id"
                >{{ item.name }}</el-checkbox
              >
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="考勤规则" prop="attendanceType">
            <el-select v-model="warehouseForm.attendanceType" class="white" placeholder="请选择考勤规制">
              <el-option
                v-for="item in attendanceList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="title">
          <span>库区库位信息</span>
          <el-button type="text" class="btn-text" @click="addWarehouseArea">+新增</el-button>
        </div>
        <div class="labor-info">
          <div
            class="row"
            v-for="(item, index) in warehouseForm.warehouseAreaList"
            :key="index"
          >
            <el-form-item label="库区名称">
              <el-input
                class="gray white"
                v-model="item.name"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="库位数量">
              <el-input
                class="gray white"
                v-model="item.num"
                placeholder="请输入"
                @input="inputWarehouseAreaNum(item.num, index)"
                clearable
              ></el-input>
            </el-form-item>
            <div class="remove" @click="removeWarehouseArea(item)">x</div>
          </div>
        </div>
      </el-form>
      <div class="dialog-footer">
        <el-button class="btn-white" @click="closeWarehouseDialog">取消</el-button>
        <el-button class="btn-blue" @click="saveWarehouse('warehouseForm')">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getInteger, getDecimal, modifyNetTitle } from "common/js/util";
import WarehouseManage from "models/warehouse-manage";
const warehouseManage = new WarehouseManage();
export default {
  data() {
    return {
      warehouseName: "",
      searchWarehouseName: "",
      tableData: [],
      warehouseDialog: false,
      warehouseForm: {
        id: "",
        name: "",
        bcPercent: "",
        area: "",
        rentPriceMonth: "",
        attendanceType: "",
        costAllocationRules: [1],
        warehouseAreaList: [
          {
            name: '',
            num: null
          }
        ]
      },
      warehouseFormRules: {
        name: [{ required: true, message: "请输入仓库名称", trigger: "blur" }],
        bcPercent: [
          { required: true, message: "请输入2C业务比重", trigger: "blur" }
        ],
        area: [{ required: true, message: "请输入面积", trigger: "blur" }],
        rentPriceMonth: [
          { required: true, message: "请输入场租月单价", trigger: "blur" }
        ],
        attendanceType: [
          {
            required: true,
            message: "请选择计费类型",
            trigger: "change"
          }
        ],
        costAllocationRules: [
          {
            required: true,
            message: "请选择成本分摊规则",
            trigger: "change"
          }
        ]
      },
      attendanceList: [
        {
          id: 0,
          name: "排班"
        },
        {
          id: 1,
          name: "调休"
        }
      ],
      /* 成本分摊规则集合 */
      costAllocationRulesList: [
        {
          id: 1,
          name: "订单数量"
        },
        {
          id: 2,
          name: "商品件数"
        }
      ]
    };
  },
  watch: {
    warehouseDialog: {
      handler(value) {
        if (!value) {
          this.$refs["warehouseForm"].resetFields();
          this.warehouseForm.id = "";
          this.warehouseForm.name = "";
          this.warehouseForm.bcPercent = "";
          this.warehouseForm.area = "";
          this.warehouseForm.rentPriceMonth = "";
          this.warehouseForm.attendanceType = "";
        }
      }
    }
  },
  created() {
    modifyNetTitle('仓库管理')
    this.warehouseList();
  },
  methods: {
    //获取仓库列表数据
    warehouseList() {
      let name = this.searchWarehouseName;
      warehouseManage.getWarehouseList(name).then(res => {
        let arr = [];
        res.result.map(value => {
          let obj = {};
          obj.id = value.id;
          obj.name = value.name;
          obj.bcPercent = value.bcPercent;
          obj.area = value.area;
          obj.rentPriceMonth = value.rentPriceMonth;
          obj.attendanceType = value.attendanceType;
          obj.attendanceRule = value.attendanceType === 0 ? "排班" : "调休";
          obj.costAllocationRules = [value.orderQuality];
          arr.push(obj);
        });
        this.tableData = arr;
      });
    },
    initDetails(id) {
      warehouseManage.postDetailsWarehouse(id).then(res => {
        if (res.success) {
          let { id, name, bcPercent, area, rentPriceMonth, attendanceType, orderQuality, warehouseAreaList } = res.result
          this.warehouseForm.id = id;
          this.warehouseForm.name = name;
          this.warehouseForm.bcPercent = bcPercent;
          this.warehouseForm.area = area;
          this.warehouseForm.rentPriceMonth = rentPriceMonth;
          this.warehouseForm.attendanceType = attendanceType;
          this.warehouseForm.costAllocationRules = [orderQuality];
          this.warehouseForm.warehouseAreaList = warehouseAreaList;
          this.addWarehouse();
        } else {
          this.$message.error(res.message)
        }
      });
    },
    //搜索
    searchWarehouse() {
      this.searchWarehouseName = this.warehouseName;
      this.warehouseList();
    },
    //新增
    addWarehouse() {
      this.warehouseDialog = true;
    },
    closeWarehouseDialog() {
      this.warehouseDialog = false;
    },
    saveWarehouse(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.warehouseForm.id) {
            let data = {};
            data.id = this.warehouseForm.id;
            data.name = this.warehouseForm.name;
            data.bcPercent = this.warehouseForm.bcPercent;
            data.area = this.warehouseForm.area;
            data.rentPriceMonth = this.warehouseForm.rentPriceMonth;
            data.attendanceType = this.warehouseForm.attendanceType;
            data.orderQuality = this.warehouseForm.costAllocationRules[0];
            data.warehouseAreaList = this.warehouseForm.warehouseAreaList
            warehouseManage.postUpdateWarehouse(data).then(res => {
              if (res.success) {
                this.warehouseList();
                this.$message.success("修改成功");
                this.closeWarehouseDialog();
              } else {
                this.$message.error(res.message);
              }
            });
          } else {
            let data = {};
            data.name = this.warehouseForm.name;
            data.bcPercent = this.warehouseForm.bcPercent;
            data.area = this.warehouseForm.area;
            data.rentPriceMonth = this.warehouseForm.rentPriceMonth;
            data.attendanceType = this.warehouseForm.attendanceType;
            data.orderQuality = this.warehouseForm.costAllocationRules[0];
            data.warehouseAreaList = this.warehouseForm.warehouseAreaList
            warehouseManage.postAddWarehouse(data).then(res => {
              if (res.success) {
                this.warehouseList();
                this.$message.success("新增成功");
                this.closeWarehouseDialog();
              } else {
                this.$message.error(res.message);
              }
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    updateWarehouse(row) {
      this.initDetails(row.id)
    },
    //2C业务比重限制
    bcPercentInput() {
      let bcPercent = this.warehouseForm.bcPercent;
      if (Number(getInteger(bcPercent)) <= 100) {
        this.warehouseForm.bcPercent = getInteger(bcPercent);
      } else {
        this.warehouseForm.bcPercent = 100;
      }
    },
    //限制面积输入
    areaInput() {
      let area = this.warehouseForm.area;
      this.warehouseForm.area = getDecimal(area);
    },
    //场租月单价输入
    rentPriceMonthInput() {
      let rentPriceMonth = this.warehouseForm.rentPriceMonth;
      this.warehouseForm.rentPriceMonth = getDecimal(rentPriceMonth);
    },
    changeCostAllocationRules() {
      if (this.warehouseForm.costAllocationRules.length > 1) {
        this.warehouseForm.costAllocationRules.splice(0,1)
      }
    },
    addWarehouseArea() {
      this.warehouseForm.warehouseAreaList.push({
        name: '',
        num: ''
      })
    },
    removeWarehouseArea(item) {
      let index = this.warehouseForm.warehouseAreaList.indexOf(item)
      if (index !== -1) {
        this.warehouseForm.warehouseAreaList.splice(index, 1)
      }
    },
    inputWarehouseAreaNum(v, index) {
      this.warehouseForm.warehouseAreaList[index].num = getInteger(v);
    }
  }
};
</script>
<style lang="scss">
.warehouse-manage {
  flex: 1;
  background: #fff;
  border-radius: 4px;
  padding: 16px;
  box-sizing: border-box;
  .search-warehouse {
    display: flex;
    justify-content: space-between;
    margin-bottom: 16px;
    .el-input {
      width: 240px;
      margin-right: 16px;
    }
  }
  .el-dialog {
    .el-form {
      padding: 0 10px;
      .el-select {
        width: 100%;
      }
      .el-date-editor {
        width: 100%;
      }
      .percent {
        display: inline-block;
        position: absolute;
        width: 40px;
        text-align: center;
        color: #cdcccc;
        right: 0;
      }
      .el-form-item {
        .el-form-item__label {
          width: 100%;
          text-align: left;
        }
        .el-form-item__content {
          width: 100%;
        }
      }
      .row {
        display: flex;
        justify-content: flex-start;
        .el-form-item {
          width: 50%;
          margin-right: 20px;
        }
        .el-form-item:last-child {
          margin-right: 0px;
        }
      }
      .title {
        margin-bottom: 10px;
        font-size: 14px;
        font-weight: 400;
        color: #666666;
        display: flex;
        justify-content: space-between;
      }
      .labor-info {
        padding: 20px;
        max-height: 240px;
        overflow-y: auto;
        border: 1px solid #eee;
        .row {
          align-items: center;
        }
        .remove {
          color: #2E68EA;
          font-size: 26px;
          cursor: pointer;
          margin-top: 12px;
        }
      }
    }
    .projectForm {
      height: 500px;
      overflow: auto;
    }
    .dialog-footer {
      margin-top: 16px;
      border-top: 1px solid #f7f7f7;
      padding-top: 16px;
      display: flex;
      justify-content: center;
    }
  }
}
</style>
